// src/pages/attendance/components/LocationDetailsPanel.jsx
import React from "react";
import { RefreshCw } from "lucide-react";

const LocationDetailsPanel = ({ locationState, distance, isOutOfZone, refreshLocation, currentTheme, isDarkMode, t }) => {
  if (!distance) return null;
  const c = currentTheme.colors;
  const statusColor = isOutOfZone ? c.danger : c.success;
  const isLoading   = locationState.isLoadingUserLocation;

  return (
    <div style={{
      background: isDarkMode ? "linear-gradient(135deg,rgba(30,41,59,0.9),rgba(15,23,42,0.95))" : "linear-gradient(135deg,#f8fafc,#f1f5f9)",
      borderRadius: "20px", padding: "24px", marginTop: "16px",
      border: `1.5px solid ${isDarkMode ? "rgba(148,163,184,0.15)" : "rgba(203,213,225,0.8)"}`,
      boxShadow: isDarkMode ? "0 8px 32px rgba(0,0,0,0.4)" : "0 4px 20px rgba(0,0,0,0.07)",
    }}>
      {/* status badge */}
      <div style={{ display: "inline-flex", alignItems: "center", gap: "10px", background: `${statusColor}15`, border: `1.5px solid ${statusColor}40`, borderRadius: "50px", padding: "10px 20px", marginBottom: "20px" }}>
        <div style={{ width: "10px", height: "10px", borderRadius: "50%", background: statusColor, boxShadow: `0 0 8px ${statusColor}`, flexShrink: 0 }} />
        <span style={{ fontSize: "14px", fontWeight: "700", color: statusColor, fontFamily: "'Cairo', sans-serif" }}>
          {isOutOfZone ? t.timeTracker.outZone : t.timeTracker.withinZone}
        </span>
      </div>

      {/* distance */}
      <div style={{ background: isDarkMode ? `${c.primary}12` : `${c.primary}08`, borderRadius: "14px", padding: "20px 24px", marginBottom: "16px", border: `1px solid ${c.primary}20`, textAlign: "center" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", marginBottom: "12px", color: c.textSecondary, fontSize: "12px", fontWeight: "600", fontFamily: "'Cairo', sans-serif", textTransform: "uppercase", letterSpacing: "0.8px" }}>
          <span>📍</span>{t.timeTracker.distanceToCenter}
        </div>
        <div style={{ display: "flex", alignItems: "baseline", justifyContent: "center", gap: "6px" }}>
          <span style={{ fontSize: "48px", fontWeight: "800", lineHeight: "1", color: c.textPrimary, fontFamily: "'Cairo', sans-serif" }}>{Math.round(distance).toLocaleString()}</span>
          <span style={{ fontSize: "16px", fontWeight: "600", color: c.textSecondary, fontFamily: "'Cairo', sans-serif", marginBottom: "6px" }}>{t.units.meters}</span>
        </div>
      </div>

      {/* refresh button */}
      <button onClick={refreshLocation} disabled={isLoading}
        style={{ width: "100%", background: isDarkMode ? `${c.primary}20` : `${c.primary}10`, border: `1.5px solid ${c.primary}35`, borderRadius: "12px", padding: "14px 20px", color: c.primary, fontSize: "14px", fontWeight: "700", fontFamily: "'Cairo', sans-serif", cursor: isLoading ? "not-allowed" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", opacity: isLoading ? 0.6 : 1, transition: "all 0.2s ease" }}
      >
        {isLoading
          ? <><div style={{ width: "16px", height: "16px", border: `2px solid ${c.primary}40`, borderTopColor: c.primary, borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />{t.timeTracker.refreshing}</>
          : <><RefreshCw size={16} />{t.timeTracker.refreshLocation}</>
        }
      </button>
      <style>{`@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`}</style>
    </div>
  );
};

export default LocationDetailsPanel;